module.exports = __webpack_public_path__ + "img/Tyara.d85694b1.png";